import script from "./NoPermission.vue?vue&type=script&setup=true&lang=js"
export * from "./NoPermission.vue?vue&type=script&setup=true&lang=js"

import "./NoPermission.vue?vue&type=style&index=0&id=78de0e70&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78de0e70"]])

export default __exports__